import { apiBaseUrl } from 'features/account/api/account'
import { TradeAreasType } from '../types'
import { TradeAreasSettingsQueryParams } from './index'
import { formatBigQuerySqlValueString, sanitizeSQLSource } from '../../utils'

export const generateQuery = (payload: TradeAreasSettingsQueryParams) => {
  const { mainSource, geomField, mode, type, time, distance, outputTable, atLocation, ldsToken } = payload

  return `CALL ${atLocation}.CREATE_ISOLINES(
    '${apiBaseUrl}',
    '${ldsToken}',
    ${formatBigQuerySqlValueString(sanitizeSQLSource(mainSource.source))},
    '${outputTable}',
    '${geomField}',
    '${mode}',
    ${type === TradeAreasType.Distance ? distance : time},
    '${type}',
    NULL
);`
}
